import React, { useState } from 'react';
import { useCart } from '../Cart/CartContext';

const Checkout: React.FC = () => {
    const { cart, getTotalPrice, clearCart } = useCart();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [postCode, setPostCode] = useState('');
    const [city, setCity] = useState('');
    const [orderDetails, setOrderDetails] = useState('');
    
    // Constant for minimum postage fee
    const POSTAGE_FEE = 29;

    // Calculate total with postage
    const getTotalWithPostage = () => {
        const subtotal = getTotalPrice();
        return subtotal + POSTAGE_FEE;
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!name || !email || !address || !postCode || !city) {
            alert('Vennligst fyll ut alle nødvendige felt');
            return;
        }

        if (cart.length === 0) {
            alert('Handlekurven er tom.');
            return;
        }
        
        // Create the email body with order details
        let emailBody = `Bestilling fra: ${name}\n`;
        emailBody += `Kunde E-post: ${email}\n`;
        emailBody += `Adresse: ${address}, ${postCode} ${city}\n\n`;
        emailBody += `Bestilling:\n`;
        
        cart.forEach(item => {
            emailBody += `- ${item.product.name}${item.selectedSize ? ` - Størrelse: ${item.selectedSize}` : ''} - Antall: ${item.quantity} - ${item.product.price * item.quantity} NOK\n`;
        });
        
        emailBody += `\nSubtotal: ${getTotalPrice()} NOK\n`;
        emailBody += `Frakt: ${POSTAGE_FEE} NOK\n`;
        emailBody += `Total: ${getTotalWithPostage()} NOK\n\n`;
        
        if (orderDetails) {
            emailBody += `Tilpasning/Beskrivelse:\n${orderDetails}\n`;
        }
        
        // Encode the email body for the mailto link
        const encodedBody = encodeURIComponent(emailBody);
        const encodedSubject = encodeURIComponent(`Ny bestilling fra ${name}`);
        
        // Open the user's default mail client with the mailto link
        window.location.href = `mailto:perlermedvilje@gmail.com?subject=${encodedSubject}&body=${encodedBody}`;

        // Show confirmation to user
        alert(`Takk, ${name}! \n\nSend e-posten for å bestille. \n\nVi kontakter deg på ${email} så snart som mulig.`);

        // Clear the form
        setName('');
        setEmail('');
        setAddress('');
        setPostCode('');
        setCity('');
        setOrderDetails('');
        clearCart();
    };

    return (
        <section className="container mt-5">
            <h2>Bestilling</h2>
            {cart.length === 0 ? (
                <p>Handlekurven er tom.</p>
            ) : (
                <>
                    <ul className="list-group">
                        {cart.map(item => (
                            <li key={`${item.product.id}-${item.selectedSize || 'default'}`} className="list-group-item d-flex justify-content-between align-items-center">
                                {item.product.name} 
                                {item.selectedSize && ` - Størrelse: ${item.selectedSize} `} 
                                - Quantity: {item.quantity} 
                                - {item.product.price * item.quantity} NOK
                            </li>
                        ))}
                    </ul>
                    <div className="mt-3 mb-3">
                        <div className="d-flex justify-content-between">
                            <span>Subtotal:</span>
                            <span>{getTotalPrice()} NOK</span>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span>Frakt:</span>
                            <span>{POSTAGE_FEE} NOK</span>
                        </div>
                        <div className="d-flex justify-content-between fw-bold">
                            <span>Total:</span>
                            <span>{getTotalWithPostage()} NOK</span>
                        </div>
                        <div className="mt-2">
                            <small className="text-muted">* Du blir tilsendt informasjon om betaling når bestillingen er klar.</small>

                        </div>
                    </div>
                </>
            )}

            <section id="order" className="mt-5">
                <form id="orderForm" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="name" className="form-label">Fullt Navn</label>
                            <input type="text" className="form-control" id="name" value={name} onChange={(e) => setName(e.target.value)} required />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="email" className="form-label">E-post</label>
                            <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="address" className="form-label">Adresse</label>
                        <input type="text" className="form-control" id="address" value={address} onChange={(e) => setAddress(e.target.value)} required />
                    </div>
                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <label htmlFor="postCode" className="form-label">Postnummer</label>
                            <input type="text" className="form-control" id="postCode" value={postCode} onChange={(e) => setPostCode(e.target.value)} required />
                        </div>
                        <div className="col-md-8 mb-3">
                            <label htmlFor="city" className="form-label">Sted</label>
                            <input type="text" className="form-control" id="city" value={city} onChange={(e) => setCity(e.target.value)} required />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="orderDetails" className="form-label">Beskrivelse</label>
                        <textarea
                            className="form-control"
                            id="orderDetails"
                            rows={4}
                            placeholder="Beskriv din tilpasning"
                            value={orderDetails}
                            onChange={(e) => setOrderDetails(e.target.value)}>
                        </textarea>
                    </div>
                    <button type="submit" className="btn btn-dark" id="submitOrder">Send inn bestilling</button>
                </form>
            </section>
        </section>
    );
};

export default Checkout;